var map = {
	"./decoration.png": 28,
	"./flags/be.svg": 29,
	"./flags/cn.svg": 30,
	"./flags/de.svg": 31,
	"./flags/es.svg": 32,
	"./flags/fr.svg": 33,
	"./flags/gb.svg": 34,
	"./flags/it.svg": 35,
	"./flags/jp.svg": 36,
	"./flags/us.svg": 37,
	"./icons/arrow-white-circle-blue.svg": 38,
	"./icons/arrow.svg": 39,
	"./icons/back.svg": 40,
	"./icons/close.svg": 41,
	"./icons/download-support.svg": 42,
	"./icons/download.svg": 43,
	"./icons/error.svg": 44,
	"./icons/facebook.svg": 45,
	"./icons/info.svg": 46,
	"./icons/instagram.svg": 47,
	"./icons/linkedin.svg": 48,
	"./icons/marker.svg": 49,
	"./icons/slider-arrow.svg": 50,
	"./icons/success.svg": 51,
	"./icons/tiktok.svg": 52,
	"./icons/twitter-x.svg": 53,
	"./icons/twitter.svg": 54,
	"./icons/weibo.svg": 55,
	"./icons/whatsapp.svg": 56,
	"./icons/youtube.svg": 57,
	"./logo.png": 58,
	"./shadow-wine.png": 59,
	"./texture-menu.png": 60,
	"./texture.jpg": 61,
	"./texture.png": 62
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27;